export default __webpack_public_path__ + "static/media/Group 3208@2x.a7221421.png";